import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";
import "./Cgu.css";
import Header from '../header/header';
import Footer from '../commun/Footer';

const PolitiqueConfidentialite = () => (

        <>

    < Header />
  <Container maxWidth="md" className="cgu-container">
    <Box py={5}>
      <Typography variant="h4" align="center" gutterBottom>
        POLITIQUE DE CONFIDENTIALITE
      </Typography>

      <Divider className="cgu-divider" />

      <Typography variant="h6" gutterBottom>
        Données collectées
      </Typography>
      <Typography paragraph>
        Lors de votre utilisation du site www.cooptaleo.com, nous pouvons collecter les données suivantes :
      </Typography>
      <ul className="cgu-list">
        <li>Informations d’identification : nom, prénom, adresse e-mail, numéro de téléphone</li>
        <li>Données professionnelles : CV, parcours, poste, rémunération, préférences de contrat</li>
        <li>Informations de navigation : adresse IP, pages visitées, actions sur le site</li>
      </ul>
      <Typography paragraph>
        Ces données sont recueillies via nos formulaires d’inscription, l’espace candidat, ou lors de votre navigation (cookies).
      </Typography>

      <Typography variant="h6" gutterBottom>
        Finalité du traitement
      </Typography>
      <Typography paragraph>
        Vos données sont utilisées pour :
      </Typography>
      <ul className="cgu-list">
        <li>Vous inscrire et vous permettre d’utiliser les services de la plateforme</li>
        <li>Mettre en relation candidats, recruteurs et entreprises</li>
        <li>Gérer votre compte utilisateur</li>
        <li>Envoyer des notifications relatives à l’activité (candidatures, réponses, etc.)</li>
        <li>Analyser l’audience du site (Google Analytics)</li>
        <li>Améliorer nos services et campagnes marketing (Meta Ads, à venir)</li>
      </ul>

      <Typography variant="h6" gutterBottom>
        Hébergement des données
      </Typography>
      <Typography paragraph>
        Les données sont hébergées chez OVH, sur des serveurs situés en Europe, dans le respect du RGPD.
      </Typography>

      <Typography variant="h6" gutterBottom>
        Durée de conservation
      </Typography>
      <Typography paragraph>
        Vos données sont conservées :
      </Typography>
      <ul className="cgu-list">
        <li>Jusqu’à suppression de votre compte</li>
        <li>Ou 3 ans après la dernière activité sur votre compte</li>
      </ul>

      <Typography variant="h6" gutterBottom>
        Sécurité
      </Typography>
      <Typography paragraph>
        Nous mettons en œuvre toutes les mesures techniques et organisationnelles pour assurer la sécurité de vos données personnelles.
      </Typography>

      <Typography variant="h6" gutterBottom>
        Droits des utilisateurs
      </Typography>
      <Typography paragraph>
        Vous disposez, selon la réglementation applicable, des droits suivants :
      </Typography>
      <ul className="cgu-list">
        <li>Droit d’accès, de rectification, d’opposition, d’effacement, de limitation du traitement</li>
        <li>Droit à la portabilité</li>
        <li>Droit d’introduire une réclamation auprès de la CNIL</li>
      </ul>
      <Typography paragraph>
        Pour exercer vos droits : contact@cooptaleo.com
      </Typography>

      <Typography variant="h6" gutterBottom>
        Responsable du traitement
      </Typography>
      <Typography paragraph>
        Le responsable du traitement est :
      </Typography>
      <Typography paragraph>
        CIT MENA INFORMATION TECHNOLOGY CONSULTANCY <br/>
        Office F1 – 261 Hor Al Anz – Dubai – UAE <br/>
        contact@cooptaleo.com
      </Typography>
    </Box>
  </Container>
   <Footer />

  </>
);

export default PolitiqueConfidentialite;
